import { phuongThucThanhToanSearchColumns } from '@/features/danh-muc/ban-hang/danh-muc-kenh-ban-hang/cols-definition';
import { FormField, SearchField } from '@/components/custom/erp';
import { PhuongThucThanhToan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

function BasicInfo({
  phuongThucThanhToan,
  setPhuongThucThanhToan
}: {
  phuongThucThanhToan: PhuongThucThanhToan | null;
  setPhuongThucThanhToan: (phuongThucThanhToan: PhuongThucThanhToan) => void;
}) {
  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='min-w-[48vw] p-4 md:p-6'>
        <div className='flex flex-col gap-y-4 md:gap-y-6'>
          <div className='space-y-2'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Ngày điều chỉnh</Label>
              <FormField type='date' name='ngay_ct' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên đơn vị</Label>
              <FormField type='text' name='ten_kh_thue' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Họ tên người mua hàng</Label>
              <FormField type='text' name='ong_ba' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã số thuế</Label>
              <FormField type='text' name='ma_so_thue' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Địa chỉ</Label>
              <FormField type='text' name='dia_chi' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Điện thoại</Label>
              <FormField type='text' name='dien_thoai' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Email</Label>
              <FormField type='text' name='e_mail' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tài khoản ngân hàng</Label>
              <FormField type='text' name='tknh' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên ngân hàng</Label>
              <FormField type='text' name='ten_nh' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Ph/th thanh toán</Label>
              <div className='flex w-full items-center gap-2'>
                <SearchField<PhuongThucThanhToan>
                  type='text'
                  displayRelatedField='ten_pttt'
                  columnDisplay='ten_pttt'
                  searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_THANH_TOAN}`}
                  searchColumns={phuongThucThanhToanSearchColumns}
                  value={phuongThucThanhToan?.ten_pttt || ''}
                  relatedFieldValue={phuongThucThanhToan?.ten_pttt || ''}
                  onRowSelection={setPhuongThucThanhToan}
                />
              </div>
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nội dung</Label>
              <FormField type='text' name='noi_dung' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Văn bản thỏa thuận</Label>
              <FormField type='text' name='van_ban_thoa_thuan' />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Ngày thỏa thuận</Label>
              <div className='flex items-center gap-2'>
                <FormField type='date' name='ngay_thoa_thuan' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BasicInfo;
